import { Component, inject, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, RouterLink } from "@angular/router";
import { MatCardModule } from "@angular/material/card";
import { MarketService } from "../../../../../shared/src/lib/services/market.service";
import { MatListModule } from "@angular/material/list";
import { SearchService } from "./search.service";
import { MatPaginatorModule } from "@angular/material/paginator";
import { LoaderService } from "../../../../../shared/src/lib/services/loader.service";
import { Observable, Subject } from "rxjs";
import { AsyncPipe } from "@angular/common";
import { AlertComponent } from "../../components/alert/alert.component";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-search-results",
  imports: [MatCardModule, MatListModule, RouterLink, MatPaginatorModule, AsyncPipe, AlertComponent],
  templateUrl: "./search-results.component.html",
  styleUrl: "./search-results.component.scss",
})
export class SearchResultsComponent implements OnInit, OnDestroy {
  readonly destroy$ = new Subject<void>();
  route = inject(ActivatedRoute);
  marketService = inject(MarketService);
  searchService = inject(SearchService);
  routeParams: any = null;
  loader = inject(LoaderService);
  $loading!: Observable<boolean>;
  searchResults: any[] = [];
  totalCount = 0;
  page = 1;
  pageSize = 10;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 20, 50, 100];
  Object = Object;

  ngOnInit() {
    this.$loading = this.loader.isLoading("/navigation/search");
    this.route.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      // console.log(params);
      this.getSearchResult(params);
      this.routeParams = params;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  filterHiddenItems(searchResult: any) {
    this.searchResults = searchResult?.content;
    this.totalCount = searchResult?.totalElements;
  }

  handlePageChange(e: any) {
    // console.log(e);
    this.pageIndex = e?.pageSize !== this.pageSize ? 0 : e?.pageIndex;
    this.page = this.pageIndex + 1;
    this.pageSize = e?.pageSize;
    this.getSearchResult({
      ...this.routeParams,
      page: this.page,
      size: this.pageSize,
    });
  }

  getSearchResult(params?: any) {
    this.marketService
      .searchItems(params)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          // console.log(response);
          if (response?.data?.content) {
            // console.log(response?.data?.content);
            const result = response?.data;
            this.searchResults = result?.content;
            this.totalCount = result?.totalElements;
          }
        },
        error: (error: any) => {
          console.error(error);
        },
      });
  }

  get startIndex(): number {
    return this.pageIndex * this.pageSize;
  }

  get endIndex(): number {
    const end = this.startIndex + this.pageSize;
    return end > this.totalCount ? this.totalCount : end;
  }
}
